import { render, staticRenderFns } from "./TendancesGraph.vue?vue&type=template&id=2974e9ba&scoped=true"
import script from "./TendancesGraph.vue?vue&type=script&lang=js"
export * from "./TendancesGraph.vue?vue&type=script&lang=js"
import style0 from "./TendancesGraph.vue?vue&type=style&index=0&id=2974e9ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2974e9ba",
  null
  
)

export default component.exports